import React from 'react';
import { useAppLayoutOptional } from '../../hooks/useAppLayout';
import { createRecoverableLazyLoader } from '../../utils/chunkErrorHandler';
import LazyChunkSuspense from '../../components/LazyChunkSuspense';
import HomeNative from './HomeNative';
import HomeClassicLoadingShell from './HomeClassicLoadingShell';

const HomeClassicWeb = React.lazy(
  createRecoverableLazyLoader(() => import('./HomeClassicWeb')),
);

/**
 * Route `/` — dispatch natif vs web sans charger le marketing web (motion, leaflet, etc.) en natif.
 */
const HomeClassic: React.FC = () => {
  const { isNative } = useAppLayoutOptional();
  if (isNative) return <HomeNative />;
  return (
    <LazyChunkSuspense fallback={<HomeClassicLoadingShell />}>
      <HomeClassicWeb />
    </LazyChunkSuspense>
  );
};

export default HomeClassic;
